const THEME = 'theme';
const TEMPLATE = 'template';
export const AssetTypes = Object.freeze({
  THEME,
  TEMPLATE
});